/**
 *
 * @/services/api/network.js
 *
 */

//
// IMPORTS
//

//

//
//
//

export const checkInternetAvailability = (timeout = 300) => {
  // console.log("[CHECK INTERNET] navigator.onLine =", navigator.onLine)
  return Promise.resolve(navigator.onLine)
}

/*
export const checkInternetAvailability = (timeout = 300) => new Promise(resolve => {
  let finished = false

  const timer = setTimeout(() => {
    if (!finished) {
      // if (__DEV__) console.log('\x1b[1m::: \x1b[35mESTADO DA REDE:\x1b[0m', 'Não foi possível detectar')
      finished = true
      resolve(true) // fallback: assume que fetch deve decidir
    }
  }, timeout)

  fetch("https://clients3.google.com/generate_204", { method: "GET" })
    .then(() => {
      if (!finished) {
        // if (__DEV__) console.log('\x1b[1m::: \x1b[35mESTADO DA REDE:\x1b[0m', '\x1b[32mConectado\x1b[0m')
        finished = true
        clearTimeout(timer)
        resolve(true)
      }
    })
    .catch(() => {
      if (!finished) {
        // if (__DEV__) console.log('\x1b[1m::: \x1b[35mESTADO DA REDE:\x1b[0m', '\x1b[31mDesconectado\x1b[0m')
        finished = true
        clearTimeout(timer)
        resolve(false)
      }
    })
})
*/
